import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';

export class FarmEntity implements Entity {
  public static fromXML(xml, matchIDs) {
    const attrs = xml._attributes;
    const isoId = attrs[ATTRS.Farm.FarmId];
    const id = matchIDs[isoId] ? matchIDs[isoId].id : null;
    return {
      entity: new FarmEntity(
        id,
        attrs[ATTRS.Farm.FarmDesignator],
        attrs[ATTRS.Farm.FarmStreet],
        attrs[ATTRS.Farm.FarmPOBox],
        attrs[ATTRS.Farm.FarmPostalCode],
        attrs[ATTRS.Farm.FarmCity],
        attrs[ATTRS.Farm.FarmState],
        attrs[ATTRS.Farm.FarmCountry]
      ),
      isoId,
    };
  }
  public type = TAGS.Farm;
  public id: string;

  constructor(
    id: string,
    private designator: string,
    private street?: string,
    private POBox?: string,
    private postalCode?: string,
    private city?: string,
    private state?: string,
    private country?: string
  ) {
    this.id = id;
  }

  public toXML(xmlId: string) {
    return {
      _attributes: {
        [ATTRS.Farm.FarmId]: xmlId,
        [ATTRS.Farm.FarmDesignator]: this.designator,
        ...(this.street && { [ATTRS.Farm.FarmStreet]: this.street }),
        ...(this.POBox && { [ATTRS.Farm.FarmPOBox]: this.POBox }),
        ...(this.postalCode && { [ATTRS.Farm.FarmPostalCode]: this.postalCode }),
        ...(this.city && { [ATTRS.Farm.FarmCity]: this.city }),
        ...(this.state && { [ATTRS.Farm.FarmState]: this.state }),
        ...(this.country && { [ATTRS.Farm.FarmCountry]: this.country }),
      },
    };
  }
}
